import angular from "angular";
import dcDropdown from "modules/dc-ui/dc-dropdown";
import dcScrollbar from "modules/dc-ui/dc-scrollbar";


import MessageService from "modules/dcb-eaccount/services/MessageService";
import UserService from "modules/dcb-eaccount/services/UserService";
import AuthenticationService from "modules/dcb-eaccount/services/AuthenticationService";
import MenuService from "modules/dcb-eaccount/services/MenuService";
import Utils from "modules/dcb-eaccount/services/Utils";

import UserController from "./UserController.js";
import dcTimeAgo from "modules/dc-ui/dc-time-ago";

export default angular.module("UserComponent", [dcTimeAgo, dcDropdown, dcScrollbar, MessageService])
  .controller("UserController", UserController)
  .directive("userComponent", function userComponent() {
    return {
      scope: { onFilterChanged: "&?" },
      bindings: {
        onFilterChanged: "&?"
      },
      controller: UserController,
      controllerAs: "headerController",
      template: require("./user-component.tpl.html")
    };
  }).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/directives/user-component/user-component.js